export default "__VITE_ASSET__VfihNJ7a__"